/**
 * True when ordering test config moves from requiring any parent comparator sample
 * to proband-only (no comparator samples). OrderStart uses this to reset canonical
 * mother/father/guardian and local family UI without relying on modal checkbox timing.
 */
export function isLeavingComparatorFamily(
  prevParentSamplesRequired: number,
  newParentSamplesRequired: number
): boolean {
  return prevParentSamplesRequired > 0 && newParentSamplesRequired === 0
}
